module.exports = __webpack_public_path__ + "img/img6.8eda03b3.jpg";